<template>
  <div style="background: rgb(242, 242, 245)">
    <div style="display: flex; background: #1a1a1a; justify-content: center">
      <top-menu />
    </div>
    <div style="display: flex; justify-content: center; min-height: 800px">
      <support-content />
    </div>
    <home-footer />
  </div>
</template>

<script>
import TopMenu from '../TopMenu';
import supportContent from './content';
import homeFooter from '../home/BottomFooter.vue';

export default {
  components: {
    supportContent,
    homeFooter,
    TopMenu
  },
  created() {},
  methods: {}
};
</script>
